module.exports = __webpack_public_path__ + "img/yellow.72def685.jpg";